define([
	"dojo/_base/declare",
	"csi/heading/RefImage"
], function(declare,RefImage) {

	return declare(RefImage, {

		_getImageNode: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return referenced image node
			var imageNode = ctx.cache.getNode(this._getValue(ctx, h), true);
			
			if (!imageNode) { // if Colorway node has no image, try to get it from ColorSpec
				var colorway = ctx.getNode();
				if (colorway && colorway.ColorSpecification) {
					var colorSpec = ctx.cache.getNode(ctx.getNode().ColorSpecification);
					if (colorSpec && colorSpec.Images && colorSpec.Images.hasOwnProperty("")) {
						imageNode = ctx.cache.getNode(colorSpec.Images[""]);
					}
				}
			}
			
			return imageNode;
		}
	
	});
});